"use client";

import PlayerPersonalData from "rivals/components/shared/PlayerPersonalData";
import { MediaContextProvider } from "rivals/media";
import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";
import type { Props } from "./types";

const AthleteBio = ({
  bioVariant,
  collegePlayer,
  data = ""
}: Props): JSX.Element => {
  return (
    <div className={styles.bioContainer} {...setData(data, "bio-container")}>
      <MediaContextProvider>
        <PlayerPersonalData
          collegePlayer={collegePlayer}
          variant={bioVariant}
        />
      </MediaContextProvider>
    </div>
  );
};

export default AthleteBio;
